<template>
  <v-dialog v-model="isLoading" persistent width="120">
    <v-card>
      <v-progress-circular :size="100" color="primary" class="loader" indeterminate>Loading</v-progress-circular>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.loader{
  margin: 10px;
}
</style>


